// extracted by mini-css-extract-plugin
module.exports = {"PlainFeature":"wo_a bhu_b"};